import React, {useState} from "react"
import "../assets/scss/form.scss"

export default function Form({ forms, upload = false }) {
    const [disabled, setDisabled] = useState(false)
    const [errors, setErrors] = useState(null)
    const [successForm, setSuccessForm] = useState(false)
    const [selectedFile, setSelectedFile] = useState();
    const [showUpload, setShowUpload] = useState(upload)

    const toggleUpload = (event) => {
        setShowUpload(!showUpload)
    }

    const changeHandler = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    function handleSubmit(e) {
        e.preventDefault()
        setDisabled(true)

        let formData = new FormData(e.target)
        // console.log('form data 1', formData)
        // if (selectedFile) {
        //     formData.append('input_8', selectedFile)
        // }
        // console.log('form data 2', formData)
        // const formProps = Object.fromEntries(formData)

        // let postObj = {
        //     form_id: form?.databaseId,
        //     input_values: formProps
        // }

        // let post = JSON.stringify(postObj)
        let post = formData
        post.append('form_id', form?.formId)
        console.log('post', post)

        const url = `https://${process.env.WP_BASE_URL}/wp-json/gf/v2/forms/${form?.formId}/submissions`
        let xhr = new XMLHttpRequest()

        xhr.open('POST', url, true)
        // xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
        xhr.send(post);

        xhr.onload = function () {
            const response = JSON.parse(xhr.response)
            const status = xhr.status
            let errorMessages = [];

            if (status === 200) {
                if (response?.is_valid) {
                    console.log('success')
                    setSuccessForm(true)
                } else {
                    console.log('response', response)
                    setDisabled(false)

                    for (let [key, value] of Object.entries(response?.validation_messages)) {
                        errorMessages[key] = value
                    }
                }
            } else {
                setDisabled(false)

                if (response?.validation_messages) {
                    for (let [key, value] of Object.entries(response?.validation_messages)) {
                        errorMessages[key] = value
                    }
                } else {
                    errorMessages.push({status: 'Try again later'})
                }
            }

            setErrors(errorMessages)

            console.log(errorMessages, errors)
        }
    }

    const [form] = forms.filter(form => form.formId === 7);

    return (
        <>
        {!successForm &&
        <form className="form-component-wrapper" onSubmit={(event) => handleSubmit(event)}>
            {form?.formFields?.map(field => {
                const error = (errors && errors[field?.id]) ? errors[field?.id] : ''
                return (
                    <div className={`gf_field gf_field_container_${field?.type?.toLowerCase()} ` + field?.cssClass}>
                        {error &&
                        <div className="error">{error}</div>
                        }
                        {(field?.type?.toLowerCase() === 'post_title' || field?.type?.toLowerCase() === 'text' || field?.type?.toLowerCase() === 'phone' || field?.type?.toLowerCase() === 'email') &&
                        <input
                            aria-invalid="false"
                            aria-required="true"
                            className={`gravityform__field__input gravityform__field__input__${field?.type?.toLowerCase()} large`}
                            id={`input_${form.databaseId}_${field?.id}`}
                            name={`input_${field?.id}`}
                            placeholder={field?.placeholder}
                            type={(field?.type?.toLowerCase() === 'post_title') ? 'text' : field?.type?.toLowerCase()}
                            required={field?.isRequired}
                        />
                        }
                        {(field?.type?.toLowerCase() === 'radio') &&
                        <>
                        <p className="gfield_radio_text">{field?.label}</p>
                        <ul className="gfield_radio" id={`input_${field?.id}`}>
                            {field?.choices?.map((choice, index) => {
                                return (
                                    <li>
                                        <label htmlFor={`input_radio_${field?.id}_${index + 1}`}>
                                            <input
                                                className={`gravityform__field__input gravityform__field__input__${field?.type?.toLowerCase()}`}
                                                id={`input_radio_${field?.id}_${index + 1}`} name={`input_${field?.id}`}
                                                type="radio" value={choice?.value} required={field?.isRequired}/>
                                            <span>{choice?.text}</span>
                                        </label>
                                    </li>
                                )
                            })}
                        </ul>
                        </>
                        }
                        {(field?.type?.toLowerCase() === 'checkbox') &&
                        <>
                        <ul className="gfield_checkbox" id={`input_${field?.id}`}>
                            {field?.choices?.map((choice, index) => {
                                return (
                                    <li>
                                        <label htmlFor={`input_checkbox_${field?.id}_${index + 1}`}>
                                            <input
                                                className={`gravityform__field__input gravityform__field__input__${field?.type?.toLowerCase()}`}
                                                id={`input_checkbox_${field?.id}_${index + 1}`} name={`input_${field?.id}`}
                                                type="checkbox" value={choice?.value} required={field?.isRequired} onChange={toggleUpload}/>
                                            <span>{choice?.text}</span>
                                        </label>
                                    </li>
                                )
                            })}
                        </ul>
                        </>
                        }
                        {(field?.type?.toLowerCase() === 'select') &&
                        <select
                            aria-invalid="false"
                            aria-required="true"
                            id={`input_${form.databaseId}_${field?.id}`}
                            name={`input_${field?.id}`}
                            placeholder={field?.placeholder}
                            required={field?.isRequired}
                        >
                            <option value="" selected disabled>{field?.placeholder}</option>
                            {field?.choices?.map((choice) => {
                                return (
                                    <option value={choice?.value}>{choice?.text}</option>
                                )
                            })}
                        </select>
                        }
                        {field?.type?.toLowerCase() === 'textarea' &&
                        <textarea
                            aria-invalid="false"
                            aria-required="true"
                            id={`input_${form.databaseId}_${field?.id}`}
                            name={`input_${field?.id}`}
                            placeholder={field?.placeholder}
                            required={field?.isRequired}
                        >
                                </textarea>
                        }
                        {field?.type?.toLowerCase() === 'fileupload' && showUpload &&
                            <>
                            <label htmlFor={`input_${form.databaseId}_${field?.id}`}>{field?.label}{field?.isRequired ? '*' : ''}</label>
                            <input
                                aria-invalid="false"
                                aria-required="true"
                                onChange={changeHandler}
                                className={`gravityform__field__input_file gravityform__field__input__${field?.type?.toLowerCase()}`}
                                id={`input_${form.databaseId}_${field?.id}`}
                                name={`input_${field?.id}`}
                                placeholder={field?.placeholder}
                                type="file"
                                required={field?.isRequired} />
                            </>
                        }
                        {field?.type?.toLowerCase() === 'html' && showUpload &&
                        <div className={`html-field`} dangerouslySetInnerHTML={{__html: field?.content}}></div>
                        }
                    </div>
                )
            })}
            <button className="button" type="submit" disabled={disabled}>{form?.button?.text}</button>
        </form>
        }
        {successForm &&
        <div className={"success-form-message-block description " + (successForm ? 'form-submitted' : '')} dangerouslySetInnerHTML={{__html: form?.confirmations[0]?.message}}></div>
        }
        </>
    )
}
